'use strict';

import LoadingView from 'standard-vote/app/scripts/views/loading.js';

module.exports = LoadingView;



// WEBPACK FOOTER //
// ./app/scripts/views/loading.js